export const assignmentStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  PENDING: 'PENDING',
  SUBMITTED: 'SUBMITTED',
  EVALUATED: 'EVALUATED',
  RETURNED: 'RETURNED',
  RE_REQUESTED: 'RE_REQUESTED',
};

export const isAssignmentSubmitted = status =>
  status === assignmentStatus.SUBMITTED ||
  status === assignmentStatus.EVALUATED ||
  status === assignmentStatus.RETURNED;
export const isAssignmentReturned = status =>
  status === assignmentStatus.RETURNED;
export const isAssignmentGraded = status =>
  status === assignmentStatus.EVALUATED || status === assignmentStatus.RETURNED;
export const isAssignmentReRequested = status =>
  status === assignmentStatus.RE_REQUESTED;
